(function($) {
	
	var $ourValues = $('section.our-values');
	var $content = $('#content');
	var valuesUpdateTimer;

	if ( $ourValues.length ) {

		$(window).resize(function(event) {
			
			clearTimeout( valuesUpdateTimer );
		
			valuesUpdateTimer = setTimeout(function(){
				var left = $content.offset().left + 15;

				$ourValues.css({
					marginLeft: -left,
					width: '100vw'
				});
			}, 10);

		}).trigger('resize');

	}

})(jQuery);